import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import {
  ElAlert, ElButton, ElDatePicker, ElDescriptions, ElDescriptionsItem, ElDialog, ElDrawer, ElForm, ElFormItem,
  ElIcon, ElInput, ElInputNumber, ElOption, ElProgress, ElSegmented, ElSelect, ElSkeleton, ElSpace, ElSwitch,
  ElTable, ElTableColumn, ElTag, ElTimeline, ElTimelineItem, ElTooltip,
} from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import { router } from './router'
import { adminQueryClient } from './queryClient'
import './styles/main.css'

const app = createApp(App)
for (const component of [
  ElAlert, ElButton, ElDatePicker, ElDescriptions, ElDescriptionsItem, ElDialog, ElDrawer, ElForm, ElFormItem,
  ElIcon, ElInput, ElInputNumber, ElOption, ElProgress, ElSegmented, ElSelect, ElSkeleton, ElSpace, ElSwitch,
  ElTable, ElTableColumn, ElTag, ElTimeline, ElTimelineItem, ElTooltip,
]) app.component(component.name!, component)

app
  .use(createPinia())
  .use(VueQueryPlugin, { queryClient: adminQueryClient })
  .use(router)
  .mount('#app')
